<div [class]="color()" [innerHTML]="svgContent()"></div>
